import React from "react";

function Instructors({ data }) {
  return (
    <div className="flex flex-wrap overflow-auto">
      {data?.instructors?.map((items, i) => {
        return (
          <div
            key={i}
            className="w-[50%] flex flex-col items-center text-center gap-2 shadow-shadowOne p-3"
          >
            <img
              className="rounded-full w-20 h-w-20"
              src={items.photoUrl}
              alt={items.title}
            />
            <h1 className="font-semibold">{items.name}</h1>
            {/* <p>{items.department}</p> */}
            <p className="text-sm">{items.title}</p>
          </div>
        );
      })}
    </div>
  );
}

export default Instructors;
